<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <article
        class="methodology"
    >
        <StoryblokComponent
            v-for="item in blok?.Body"
            :key="item._uid"
            v-editable="item"
            :blok="item"
        />
    </article>
</template>
